import React, { useContext, useState } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Card } from "@material-ui/core";
import { LangContext } from "../../context/lang";
import { FaRegFilePdf } from "react-icons/fa";
import ReactPlayer from "react-player";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
    overflowY: "auto",
  },
  container: {
    height: `calc(100% - ${theme.spacing(-2)}px)`,
  },
  content: { height: "100%", width: "100%" },
  icon: {
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(1),
  },
  iconactive: {
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(1),
  },
  title: { maxWidth: "85%" },
  cardstyle: {
    width: "100%",
    backgroundColor: "#faf7f1",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    height: "10rem",
    cursor: "pointer",
    "&:hover": {
      background: "#faf7f1",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  center: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  videocontent: {
    height: "35rem",
    width: "100%",
    // padding: theme.spacing(1),
  },
}));

const Document = () => {
  const classes = useStyle();
  const { lang } = useContext(LangContext);
  const [index, setIndex] = useState<Number>(0);

  const doc = [
    {
      title: "คู่มือการใช้งาน web application การออกแบบระบบไฟฟ้า",
      link:
        "https://upload.i-bitz.co.th/files/2020/08/25/87945faded6a7497df721302.pdf",
      icon: <FaRegFilePdf size={42} className={classes.icon} />,
      iconactive: <FaRegFilePdf size={42} className={classes.iconactive} />,
    },
  ];

  const openLink = (link: string) => {
    let a = document.createElement("a");
    a.href = link;
    a.target = "_blank";
    a.click();
  };
  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>{lang.data.document}</Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <div className={classes.videocontent}>
            <ReactPlayer
              url="https://upload.i-bitz.co.th/files/2020/08/25/d812248a68b0e643c56f9cae.mov"
              controls
              width="100%"
              height="100%"
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Grid container spacing={2}>
            {doc.map((rs: any, id: any) => {
              return (
                <Grid
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={12}
                  key={`${rs.title}_${id}`}
                >
                  <Card
                    className={classes.cardstyle}
                    onClick={() => {
                      openLink(rs.link);
                    }}
                    onMouseEnter={() => {
                      setIndex(id + 1);
                    }}
                    onMouseLeave={() => {
                      setIndex(0);
                    }}
                  >
                    <div className={classes.center}>
                      {Number(id + 1) === index ? rs.iconactive : rs.icon}
                      <Typography className={classes.title}>
                        {rs.title}
                      </Typography>
                    </div>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Document;
